import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../assets/css/home_style.css";
import "../assets/css/Responsive/home_responsive.css";
// import { FaTools } from "react-icons/fa";
// import { FaClipboardCheck } from "react-icons/fa";
// import { FaIndustry } from "react-icons/fa";
import qualityImg from "../assets/images/home/quality_product1.webp"; // replace with your image
import efficiencyImg from "../assets/images/home/efficiency_product.webp"; // replace with your image
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import hero1 from "../assets/images/home/hero_brass.webp";
import hero2 from "../assets/images/home/hero_brass2.webp";
import hero3 from "../assets/images/home/hero_brass3.webp";
// import hero4 from "../assets/images/home/hero_brass4.webp";
import icon1 from "../assets/images/home/card1_icon.webp";
import icon2 from "../assets/images/home/card2_icon.webp";
import icon3 from "../assets/images/home/card3_icon.webp";
import why_icon1 from "../assets/images/home/why_icon1.webp";
import why_icon2 from "../assets/images/home/why_icon2.webp";
import why_icon3 from "../assets/images/home/why_icon3.webp";
import why_icon4 from "../assets/images/home/why_icon4.webp";
import why_icon5 from "../assets/images/home/why_icon5.webp";
import why_icon6 from "../assets/images/home/why_icon6.webp";
import ProcessSection from "../Components/ProcessSection";
import HeroSection from "../Components/HeroSection";

export default function Home() {
  document.title = "Milan Brass – Home";
  useEffect(() => {
    AOS.init({
      duration: 800, // slower & smoother
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  // const slides = [hero1, hero2, hero3, hero4];
  const slides = [
    {
      img: hero1,
      title: "Welcome To Milan Brass",
      description:
        "Innovating with Every Brass Element. <br /> Milan Brass Industry — Precision that Performs.",
    },
    {
      img: hero2,
      title: "High Quality Brass Products",
      description:
        "Manufacturing excellence with cutting-edge technology <br /> Delivering trusted brass solutions worldwide.",
    },
    {
      img: hero3,
      title: "Trusted by Global Clients",
      description:
        "Commitment to durability, precision and innovation. <br /> Serving industries across the globe.",
    },
  ];

  return (
    <div>
      <div className="home_container">
        <div className="home">
          {/* Hero Section */}
          {/* <section className="hero"> */}
          {/* <Swiper
              modules={[Autoplay]}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              speed={1000}
              className="hero-swiper"
              slidesPerView={1}
            >
              {slides.map((slide, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="hero-slide"
                    style={{ backgroundImage: `url(${slide.img})` }}
                  >
                    <div className="hero-overlay"></div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper> */}

          {/* ✅ Fixed Content (won’t change on slide) */}
          {/* <div
              className="hero-content"
              data-aos="fade-up"
              data-aos-duration="2000"
            >
              <h1
                data-aos="fade-up"
                data-aos-duration="1500"
                data-aos-delay="200"
              >
                Welcome To Milan Brass
              </h1>
              <p
                data-aos="fade-up"
                data-aos-duration="1500"
                data-aos-delay="400"
              >
                Innovating with Every Brass Element. <br />
                Milan Brass Industry — Precision that Performs.
              </p>
            </div> */}
          {/* <HeroSection /> */}
          {/* </section> */}
          {/* NEW HERO - DESKTOP / TABLET */}
          <div className="new-hero-desktop">
            <HeroSection />
          </div>

          {/* OLD HERO - MOBILE ONLY */}
          <div className="old-hero-mobile">

            <section className="hero">
              <Swiper
                modules={[Autoplay]}
                loop={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                speed={1000}
                className="hero-swiper"
                slidesPerView={1}
              >
                {slides.map((slide, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="hero-slide"
                      style={{
                        backgroundImage: `url(${slide.img})`,
                      }}
                    >
                      <div className="hero-overlay"></div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              <div className="hero-content">

                <h1>
                  Welcome To Milan Brass
                </h1>

                <p>
                  Innovating with Every Brass Element.
                  <br />
                  Milan Brass Industry — Precision that Performs.
                </p>

              </div>
            </section>

          </div>
          {/* Features Section */}
          <section className="features-sec2">
            <div className="feature-card-sec2" data-aos="fade-left">
              {/* <FaTools className="feature-icon" /> */}
              <img src={icon1} alt="card-icon1" />
              <h3>CUSTOMIZED PRODUCTS</h3>
              <p>
                We have a large range of options for those who are looking for
                the right choice in the exclusive Brass Components.
              </p>
            </div>
            <div className="feature-card-sec2" data-aos="fade-up">
              {/* <FaClipboardCheck className="feature-icon" /> */}
              <img src={icon2} alt="card-icon1" />
              <h3>QUALITY ASSURANCE</h3>
              <p>
                We have well-trained & skilled staff in each and every
                department. Our goods are manufactured under the strict Quality.
              </p>
            </div>
            <div className="feature-card-sec2" data-aos="fade-right">
              {/* <FaIndustry className="feature-icon" /> */}
              <img src={icon3} alt="card-icon1" />
              <h3>INFRASTRUCTURE</h3>
              <p>
                We are well equipped with the latest plant and machinery to
                manufacture high-class quality Products work culture.
              </p>
            </div>
          </section>
          {/* About Section */}
          <section
            className="about"
            data-aos="fade-up"
            data-aos-offset="200"
            data-aos-delay="50"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
          >
            <h2>ABOUT MILAN BRASS PRODUCT</h2>
            <p>
              As we continue to grow and expand, our mission remains the same:
              to provide innovative, high-quality brass products that contribute
              to the success of our clients and partners. At Milan Brass
              Product, we are shaping the future of brass manufacturing with
              precision, excellence, and integrity.
            </p>
          </section>
          <ProcessSection />
          <section className="home-quality-section">
            {/* Section 1: Delivering Quality Products */}
            <div className="heading" data-aos="fade-up">
              <h2 className="section-title">Delivering Quality Products</h2>
            </div>
            <div className="quality-container">
              <div className="quality-left" data-aos="fade-right">
                <img src={qualityImg} alt="Quality Product" />
              </div>
              <div className="quality-right" data-aos="fade-left">
                <p className="section-desc">
                  We at Milan Brass ensure providing the best possible
                  product/service to customers. We focus on improving the
                  processes to deliver Quality Products to our valued customers.
                </p>
                <div className="divider" data-aos="zoom-in"></div>
                <p
                  className="commitment"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  We’re committed to customer satisfaction by manufacturing
                  quality products.
                </p>
                <h3
                  className="experience"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  15+ <span>Years of Manufacturing Experience & Counting</span>
                </h3>
              </div>
            </div>

            {/* Section 2: Efficiency & Delivery */}
            <div className="heading" data-aos="fade-up">
              <h2 className="section-title">
                We’re Focused On Efficiency, <br />
                Performance & Delivery
              </h2>
              <div className="divider1" data-aos="zoom-in"></div>
            </div>
            <div className="efficiency-container">
              <div className="efficiency-left" data-aos="fade-right">
                <p className="section-desc">
                  Use Quality Assurance to ensure that the product is designed
                  and implemented with correct procedures. This helps to reduce
                  problems and errors in the final product. Our aim of Quality
                  control is to check whether or not the products meet the
                  specifications and requirements of the customer, which
                  evaluates people on their quality level skill sets and imparts
                  training and certifications. Milan Brass helps provide
                  “perfect” service to our valued customers globally.
                </p>
              </div>
              <div className="efficiency-right" data-aos="fade-left">
                <img src={efficiencyImg} alt="Efficiency Product" />
              </div>
            </div>
          </section>
          <section className="why-milan-brass">
            {/* Section Title */}
            <div className="why-title" data-aos="fade-up">
              <h2>Why Milan Brass</h2>
              <p>
                We’re committed to customer satisfaction by manufacturing
                quality products.
              </p>
            </div>

            {/* Features Grid */}
            <div className="features-grid">
              <div
                className="feature-card"
                data-aos="zoom-in"
                data-aos-delay="0"
              >
                <div className="icon">
                  <img src={why_icon1} alt="why-icon-1" />
                </div>
                <h3>Vast Experience</h3>
                <p>
                  20+ years of experience in brass products manufacturing and
                  Supplying Brass Products.
                </p>
              </div>

              <div
                className="feature-card"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div className="icon">
                  <img src={why_icon2} alt="why-icon-2" />
                </div>
                <h3>Professional Team</h3>
                <p>
                  Professional and experienced team for greater understanding of
                  customer needs.
                </p>
              </div>

              <div
                className="feature-card"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div className="icon">
                  <img src={why_icon3} alt="why-icon-3" />
                </div>
                <h3>Product Quality</h3>
                <p>
                  Delivery of Best in class products is the base of our
                  existence in Industry.
                </p>
              </div>

              <div
                className="feature-card"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <div className="icon">
                  <img src={why_icon4} alt="why-icon-4" />
                </div>
                <h3>Range of Products</h3>
                <p>
                  Wide range of products from almost all brass categories at
                  single place.
                </p>
              </div>

              <div
                className="feature-card"
                data-aos="zoom-in"
                data-aos-delay="400"
              >
                <div className="icon">
                  <img src={why_icon5} alt="why-icon-5" />
                </div>
                <h3>Attractive rates</h3>
                <p>
                  Most Competitive rates compared our competitors and deliver
                  value for money.
                </p>
              </div>

              <div
                className="feature-card"
                data-aos="zoom-in"
                data-aos-delay="500"
              >
                <div className="icon">
                  <img src={why_icon6} alt="why-icon-6" />
                </div>
                <h3>Time Line</h3>
                <p>
                  Delivery of orders within the committed timelines is part of
                  our Culture.
                </p>
              </div>
            </div>
          </section>
          {/* Footer Text */}
          <div className="why-footer">
            <h3 data-aos="fade-up" data-aos-duration="1000">
              Brass parts-Products Manufacturers in Jamnagar, India
            </h3>
            <p data-aos="fade-up" data-aos-duration="1000">
              Follow our posts on "India Mart" for our exclusive range of brass
              parts products in various categories.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
